import { Chip, TextField } from '@mui/material';
import React from 'react'
import { useSelector } from 'react-redux';
import { deleteSingleMustBuyData, updateMustBuyData } from '../../../../../stateManagement/actions/manageCouponActions';
import CouponConfigurableLabel from '../../CouponConfigurableLabel';

function MustBuySelected({tabsList}:{tabsList:string[]}) {
    const { data: mustBuy } = useSelector((state: any) => state.manageCoupons?.data?.mustBuy);

    const handleDelete = (id:string,keyToDelete:string)=>{
        deleteSingleMustBuyData(id,keyToDelete,tabsList);
    }

    const generateStringFromValues = (value:string[])=>{
        if(!value || value?.length === 0) return "";
        let str = "";
        value?.forEach((item)=>str+=item+" ");
        return str;   
    }

    const handleMinQtyChange = (id:string,value:number)=>{
        const newData = mustBuy.map((item:{id:string , min_qty:string | number})=>{
            if(item.id === id){
                item.min_qty = value;
            }
            return item;
        })
        updateMustBuyData(newData);
    }

    return (
        <div className='must-buy-selected-wrapper'>
            {
                mustBuy.map((item: any) => {
                    return <div className='must-buy-single-selected-wrapper' key={item.id}>
                        <div className="must-buy-single-selected-wrapper-left">
                            {
                                Object.keys(item).map((key:string)=>{
                                    const str = key === "id" || key === "min_qty" ? "" :generateStringFromValues(item[key]);
                                    if(key === "id" || key === "min_qty" || !item[key] ||item[key].length ===0) return <></>
                                    return <Chip
                                     variant="outlined" 
                                     key={str}
                                     sx={{
                                        margin:'0 3px',
                                        height:'auto',                     
                                        padding:'5px 0',
                                        '& .MuiChip-label': {
                                          display: 'block',
                                          maxWidth:'420px',
                                          maxHeight: "300px",
                                          overflow: "scroll",   
                                          whiteSpace: 'normal',
                                        },
                                      }}
                                     label={
                                        <p className='must-buy-single-selected-chip-wrapper'>
                                            <span className='must-buy-single-selected-chip-key'>{
                                                <CouponConfigurableLabel text={key}/>
                                            } : </span>
                                            <div className='must-buy-single-selected-chip-values-wrapper'>
                                                {
                                                    item[key].map((value:string)=>{
                                                        return <span className='must-buy-single-selected-chip-value'>{value}</span>
                                                    })
                                                }
                                            </div>
                                        </p>
                                     } onDelete={()=>handleDelete(item.id,key)}/>
                                })
                            }
                        </div>
                        <div className="must-buy-single-selected-wrapper-right">
                            <span className='' 
                                style={{ 
                                    whiteSpace: 'nowrap', 
                                    marginRight: '8px',
                                    color:'var(--dashboard-theme-color)',
                                    fontWeight:800,
                                    }}>Min Qty   <span style={{ color: '#ff5733' }}>*</span> </span>
                            <TextField
                                size='small'
                                sx={{display:'inline'}}
                                required
                                onWheel={(e:any) => e.target.blur()}
                                onChange={(e:any)=>handleMinQtyChange(item.id , e?.target?.value)}
                                type='number'
                                defaultValue={item.min_qty}
                                id="must-buy-min-qty"
                                placeholder='Write here'
                            />
                        </div>

                    </div>
                })
            }
        </div>
    )
}

export default MustBuySelected